import { Building2, Hotel, Snowflake, Wind, Zap, CalendarCheck, Home } from "lucide-react";

/**
 * Konten halaman SEO / Google Ads (structured content).
 * Setiap halaman punya H1, meta, dan FAQ unik untuk menghindari duplicate content.
 * Tambah halaman baru: tambahkan objek baru + daftarkan route di App.js.
 */
export const seoPages = {
  "maintenance-ac-kantor": {
    slug: "maintenance-ac-kantor",
    icon: Building2,
    kicker: "Maintenance AC Kantor",
    h1: "Maintenance AC Kantor di Makassar",
    heroImage:
      "https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    heroImageAlt: "Ruang kantor modern yang membutuhkan perawatan AC berkala",
    intro:
      "Perawatan AC kantor secara berkala untuk membantu menjaga kenyamanan ruang kerja dan kelancaran operasional perusahaan Anda di Makassar.",
    seo: {
      title: "Maintenance AC Kantor Makassar | CV Angkasa Briliant",
      description:
        "Layanan preventive maintenance & service AC kantor di Makassar untuk perusahaan. Survey, assessment, dan kontrak maintenance AC & HVAC. Konsultasi via WhatsApp.",
      keywords:
        "maintenance AC kantor Makassar, service AC kantor Makassar, preventive maintenance AC kantor, kontrak maintenance AC kantor, vendor AC kantor Makassar",
    },
    benefitsTitle: "Mengapa Maintenance AC Kantor Penting?",
    benefits: [
      "Menjaga kenyamanan ruang kerja karyawan sepanjang hari operasional.",
      "Membantu perawatan dilakukan lebih terencana, bukan menunggu kerusakan.",
      "Mendukung kestabilan operasional kantor dan produktivitas tim.",
      "Dokumentasi pekerjaan yang tersusun untuk kebutuhan pengelolaan fasilitas.",
    ],
    faqs: [
      { id: "k1", question: "Apakah melayani maintenance AC untuk perkantoran?", answer: "Ya. Layanan kami diarahkan untuk kebutuhan perusahaan dan perkantoran, termasuk perawatan berkala dan kontrak maintenance." },
      { id: "k2", question: "Apakah bisa kontrak maintenance rutin untuk kantor?", answer: "Bisa. Kami menyediakan program maintenance berkala (Maintenance Contract) untuk kantor yang membutuhkan perawatan rutin." },
      { id: "k3", question: "Apakah dilakukan survey lokasi kantor terlebih dahulu?", answer: "Ya. Kami dapat melakukan survey dan assessment untuk memeriksa kondisi unit dan kebutuhan sebelum menentukan layanan dan penawaran." },
      { id: "k4", question: "Area mana yang dilayani?", answer: "Kami fokus melayani kebutuhan AC & HVAC di Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  "maintenance-ac-hotel": {
    slug: "maintenance-ac-hotel",
    icon: Hotel,
    kicker: "Maintenance AC Hotel",
    h1: "Maintenance AC Hotel di Makassar",
    heroImage:
      "https://images.unsplash.com/photo-1705579605238-24a90c8799c5?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    heroImageAlt: "Sistem pendingin dan HVAC untuk fasilitas hotel",
    intro:
      "Perawatan AC & HVAC hotel secara berkala untuk membantu menjaga kenyamanan tamu, kualitas layanan, dan kelancaran operasional properti Anda di Makassar.",
    seo: {
      title: "Maintenance AC Hotel Makassar | CV Angkasa Briliant",
      description:
        "Layanan preventive maintenance & service AC/HVAC hotel di Makassar. Perawatan berkala untuk kamar, lobby, dan area publik. Survey & kontrak maintenance. Chat WhatsApp.",
      keywords:
        "maintenance AC hotel Makassar, service AC hotel Makassar, maintenance HVAC hotel, preventive maintenance AC hotel, kontrak maintenance AC hotel Makassar",
    },
    benefitsTitle: "Mengapa Maintenance AC Hotel Penting?",
    benefits: [
      "Menjaga kenyamanan tamu di kamar, lobby, dan area publik.",
      "Mendukung kualitas layanan dan pengalaman menginap yang konsisten.",
      "Perawatan terencana membantu mengurangi risiko gangguan mendadak.",
      "Dokumentasi pekerjaan yang rapi untuk kebutuhan pengelolaan properti.",
    ],
    faqs: [
      { id: "h1", question: "Apakah melayani maintenance AC & HVAC untuk hotel?", answer: "Ya. Layanan kami mencakup perawatan AC dan sistem HVAC untuk kebutuhan hotel dan hospitality." },
      { id: "h2", question: "Apakah tersedia kontrak maintenance untuk hotel?", answer: "Ya. Kami menyediakan program maintenance berkala untuk properti hotel yang membutuhkan perawatan rutin." },
      { id: "h3", question: "Apakah dilakukan survey dan assessment lebih dulu?", answer: "Ya. Survey dan assessment dilakukan untuk memeriksa kondisi unit dan kebutuhan maintenance sebelum penawaran." },
      { id: "h4", question: "Area mana yang dilayani?", answer: "Kami fokus melayani kebutuhan AC & HVAC di Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  ac: {
    slug: "ac",
    icon: Snowflake,
    audience: "both",
    kicker: "Layanan AC",
    h1: "Service & Maintenance AC di Makassar",
    heroImage:
      "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    heroImageAlt: "Teknisi melakukan perawatan unit AC",
    intro:
      "Layanan lengkap AC — cleaning, service, repair, instalasi, dan preventive maintenance untuk rumah dan bisnis di Makassar & sekitarnya.",
    seo: {
      title: "Service & Maintenance AC Makassar | SEJUKARA – CV Angkasa Briliant",
      description:
        "Layanan cuci AC, service AC, repair, instalasi dan maintenance AC untuk rumah dan bisnis di Makassar. SEJUKARA by CV Angkasa Briliant. Chat WhatsApp.",
      keywords:
        "service AC Makassar, cuci AC Makassar, repair AC Makassar, instalasi AC Makassar, maintenance AC Makassar",
    },
    benefitsTitle: "Kenapa Pilih SEJUKARA untuk AC?",
    benefits: [
      "Layanan menyeluruh: cleaning, service, repair, hingga instalasi.",
      "Untuk unit rumah maupun komersial (split, cassette, standing, dan lainnya).",
      "Pendekatan perawatan berkala yang lebih terencana.",
      "Dokumentasi pekerjaan yang tersusun rapi.",
    ],
    faqs: [
      { id: "ac1", question: "Layanan AC apa saja yang tersedia?", answer: "Cleaning, service, repair, instalasi, inspeksi, troubleshooting, dan preventive maintenance untuk unit AC." },
      { id: "ac2", question: "Apakah melayani AC rumah dan komersial?", answer: "Ya. Kami melayani unit AC untuk hunian maupun kebutuhan bisnis dan fasilitas komersial." },
      { id: "ac3", question: "Bagaimana cara memesan layanan?", answer: "Anda dapat menghubungi kami via WhatsApp atau mengisi formulir permintaan penawaran di halaman ini." },
      { id: "ac4", question: "Area mana yang dilayani?", answer: "Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  hvac: {
    slug: "hvac",
    icon: Wind,
    audience: "b2b",
    kicker: "Layanan HVAC",
    h1: "Maintenance HVAC di Makassar",
    heroImage:
      "https://images.pexels.com/photos/32032996/pexels-photo-32032996.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    heroImageAlt: "Sistem ventilasi HVAC pada fasilitas komersial",
    intro:
      "Perawatan sistem HVAC untuk fasilitas komersial dan gedung — inspeksi, troubleshooting, ducting, dan distribusi udara.",
    seo: {
      title: "Maintenance HVAC Makassar | SEJUKARA – CV Angkasa Briliant",
      description:
        "Layanan maintenance HVAC di Makassar untuk gedung dan fasilitas komersial: inspeksi, troubleshooting, ducting, dan distribusi udara. SEJUKARA by CV Angkasa Briliant.",
      keywords:
        "maintenance HVAC Makassar, service HVAC Makassar, HVAC ducting Makassar, vendor HVAC Makassar, perawatan HVAC gedung",
    },
    benefitsTitle: "Mengapa Maintenance HVAC Penting?",
    benefits: [
      "Membantu menjaga performa sistem HVAC gedung dan fasilitas.",
      "Perawatan terencana untuk mengurangi risiko gangguan mendadak.",
      "Mendukung kenyamanan dan kelancaran operasional.",
      "Dokumentasi kondisi sistem untuk kebutuhan pengelolaan fasilitas.",
    ],
    faqs: [
      { id: "hv1", question: "Apakah melayani maintenance HVAC untuk gedung?", answer: "Ya. Layanan HVAC kami diarahkan untuk kebutuhan gedung dan fasilitas komersial." },
      { id: "hv2", question: "Apakah mencakup ducting dan distribusi udara?", answer: "Ya, sesuai kebutuhan sistem, termasuk inspeksi, troubleshooting, ducting, dan distribusi udara." },
      { id: "hv3", question: "Apakah tersedia kontrak maintenance HVAC?", answer: "Tersedia program maintenance berkala untuk fasilitas yang membutuhkan perawatan rutin." },
      { id: "hv4", question: "Area mana yang dilayani?", answer: "Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  electrical: {
    slug: "electrical",
    icon: Zap,
    audience: "both",
    kicker: "Layanan Electrical",
    h1: "Layanan Electrical untuk AC & HVAC di Makassar",
    heroImage:
      "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    heroImageAlt: "Teknisi memeriksa panel kelistrikan",
    intro:
      "Dukungan kelistrikan untuk sistem AC & HVAC — inspeksi, troubleshooting, instalasi, dan perawatan panel.",
    seo: {
      title: "Layanan Electrical AC & HVAC Makassar | SEJUKARA – CV Angkasa Briliant",
      description:
        "Layanan electrical pendukung AC & HVAC di Makassar: inspeksi, troubleshooting, instalasi, dan perawatan panel. SEJUKARA by CV Angkasa Briliant.",
      keywords:
        "electrical Makassar, panel maintenance Makassar, electrical AC HVAC Makassar, instalasi listrik AC Makassar",
    },
    benefitsTitle: "Dukungan Electrical yang Terintegrasi",
    benefits: [
      "Inspeksi dan troubleshooting kelistrikan pendukung AC/HVAC.",
      "Perawatan panel untuk mendukung keandalan sistem.",
      "Instalasi kelistrikan pendukung pekerjaan AC/HVAC.",
      "Ditangani bersamaan dengan kebutuhan AC & HVAC Anda.",
    ],
    faqs: [
      { id: "el1", question: "Layanan electrical apa yang tersedia?", answer: "Inspeksi, troubleshooting, instalasi, perawatan panel, dan dukungan kelistrikan untuk sistem AC/HVAC." },
      { id: "el2", question: "Apakah untuk kebutuhan AC/HVAC saja?", answer: "Fokus kami adalah dukungan kelistrikan yang berkaitan dengan sistem AC & HVAC." },
      { id: "el3", question: "Bagaimana cara berkonsultasi?", answer: "Hubungi kami via WhatsApp atau isi formulir penawaran di halaman ini." },
      { id: "el4", question: "Area mana yang dilayani?", answer: "Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  "preventive-maintenance": {
    slug: "preventive-maintenance",
    icon: CalendarCheck,
    audience: "b2b",
    kicker: "Preventive Maintenance",
    h1: "Preventive Maintenance AC & HVAC di Makassar",
    heroImage:
      "https://images.pexels.com/photos/7347538/pexels-photo-7347538.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    heroImageAlt: "Teknisi melakukan inspeksi preventive maintenance",
    intro:
      "Program perawatan berkala yang terencana untuk membantu menjaga performa AC & HVAC sebelum terjadi gangguan.",
    seo: {
      title: "Preventive Maintenance AC & HVAC Makassar | SEJUKARA – CV Angkasa Briliant",
      description:
        "Preventive maintenance AC & HVAC di Makassar: pemeriksaan rutin, cleaning berkala, condition assessment, dan dokumentasi. SEJUKARA by CV Angkasa Briliant.",
      keywords:
        "preventive maintenance AC Makassar, preventive maintenance HVAC Makassar, perawatan berkala AC, maintenance terjadwal Makassar",
    },
    benefitsTitle: "Jangan Tunggu Rusak. Jadwalkan Perawatan.",
    benefits: [
      "Pemeriksaan rutin dan cleaning berkala yang terjadwal.",
      "Condition assessment untuk memantau kondisi unit.",
      "Dokumentasi pekerjaan dan riwayat maintenance.",
      "Membantu perencanaan perawatan yang lebih terstruktur.",
    ],
    faqs: [
      { id: "pm1", question: "Apa itu preventive maintenance?", answer: "Perawatan berkala yang terencana untuk membantu menjaga performa unit sebelum terjadi gangguan." },
      { id: "pm2", question: "Apakah bisa dijadwalkan rutin?", answer: "Ya. Kami menyediakan program maintenance berkala yang dapat disesuaikan dengan kebutuhan." },
      { id: "pm3", question: "Apakah pekerjaan didokumentasikan?", answer: "Ya, struktur dokumentasi dapat digunakan untuk mencatat pekerjaan dan riwayat maintenance." },
      { id: "pm4", question: "Area mana yang dilayani?", answer: "Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  "service-ac-rumah": {
    slug: "service-ac-rumah",
    icon: Home,
    audience: "b2c",
    showResidential: true,
    primaryCtaLabel: "JADWALKAN SERVICE AC",
    secondaryLabel: "WHATSAPP SEKARANG",
    kicker: "Untuk Rumah",
    h1: "Cuci & Service AC Rumah di Makassar",
    heroImage:
      "https://images.unsplash.com/photo-1762341123870-d706f257a12e?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    heroImageAlt: "Unit AC split di dinding rumah",
    intro:
      "Cuci AC, service AC, pemeriksaan, dan instalasi untuk hunian Anda. Cepat dan mudah dijadwalkan langsung via WhatsApp.",
    seo: {
      title: "Cuci & Service AC Rumah Makassar | SEJUKARA – CV Angkasa Briliant",
      description:
        "Jasa cuci AC dan service AC rumah di Makassar: pembersihan, pemeriksaan, maintenance berkala, dan instalasi. Jadwalkan via WhatsApp SEJUKARA by CV Angkasa Briliant.",
      keywords:
        "cuci AC rumah Makassar, service AC rumah Makassar, jasa cuci AC Makassar, service AC panggilan Makassar, tukang AC Makassar",
    },
    benefitsTitle: "Layanan AC Rumah dari SEJUKARA",
    benefits: [
      "Cuci & service AC rumah agar kembali dingin dan bersih.",
      "Pemeriksaan kondisi unit untuk mencegah kerusakan.",
      "Maintenance berkala agar AC lebih awet dan hemat.",
      "Instalasi AC baru untuk hunian.",
    ],
    faqs: [
      { id: "sr1", question: "Apakah melayani cuci AC di rumah?", answer: "Ya. Kami melayani cuci AC, service, pemeriksaan, maintenance berkala, instalasi, dan troubleshooting untuk hunian." },
      { id: "sr2", question: "Bagaimana cara memesan?", answer: "Cukup hubungi kami via WhatsApp untuk menjadwalkan kunjungan." },
      { id: "sr3", question: "Jenis AC apa saja yang dilayani?", answer: "Umumnya AC split untuk rumah, serta jenis lain sesuai kebutuhan." },
      { id: "sr4", question: "Area mana yang dilayani?", answer: "Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  "service-ac": {
    slug: "service-ac", icon: Snowflake, audience: "both", kicker: "Service AC",
    h1: "Service AC di Makassar", heroImage: "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    heroImageAlt: "Teknisi melakukan service AC",
    intro: "Service AC untuk rumah dan bisnis — pembersihan, pemeriksaan, dan perbaikan agar unit kembali optimal.",
    seo: { title: "Service AC Makassar | SEJUKARA – CV Angkasa Briliant", description: "Jasa service AC di Makassar untuk rumah dan bisnis: cuci, pemeriksaan, dan perbaikan. SEJUKARA by CV Angkasa Briliant.", keywords: "service AC Makassar, jasa service AC Makassar, cuci AC Makassar" },
    benefitsTitle: "Kenapa Service AC dengan SEJUKARA?",
    benefits: ["Ditangani teknisi berpengalaman.", "Untuk unit rumah maupun komersial.", "Pemeriksaan menyeluruh.", "Dokumentasi pekerjaan yang rapi."],
    faqs: [
      { id: "s1", question: "Apa saja yang termasuk service AC?", answer: "Pembersihan unit, pemeriksaan kondisi, dan perbaikan sesuai kebutuhan." },
      { id: "s2", question: "Bagaimana cara memesan?", answer: "Hubungi kami via WhatsApp atau isi formulir di halaman ini." },
      { id: "s3", question: "Area mana yang dilayani?", answer: "Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  "ac-maintenance": {
    slug: "ac-maintenance", icon: CalendarCheck, audience: "b2b", kicker: "AC Maintenance",
    h1: "AC Maintenance untuk Bisnis di Makassar", heroImage: "https://images.pexels.com/photos/7347538/pexels-photo-7347538.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    heroImageAlt: "Perawatan AC untuk kebutuhan bisnis",
    intro: "Perawatan AC yang terjadwal dan terdokumentasi untuk perusahaan, gedung, dan fasilitas komersial di Makassar.",
    seo: { title: "AC Maintenance Makassar | SEJUKARA – CV Angkasa Briliant", description: "Layanan AC maintenance untuk bisnis di Makassar: perawatan terjadwal, service report, dan kontrak maintenance. SEJUKARA by CV Angkasa Briliant.", keywords: "AC maintenance Makassar, maintenance AC kantor Makassar, kontrak maintenance AC" },
    benefitsTitle: "Maintenance AC yang Terstruktur",
    benefits: ["Jadwal perawatan yang terencana.", "Service report setiap kunjungan.", "Riwayat maintenance terdokumentasi.", "Mendukung keandalan operasional."],
    faqs: [
      { id: "m1", question: "Apakah tersedia kontrak maintenance?", answer: "Ya, tersedia program maintenance berkala untuk perusahaan." },
      { id: "m2", question: "Apakah pekerjaan didokumentasikan?", answer: "Ya, termasuk service report dan riwayat maintenance." },
      { id: "m3", question: "Area mana yang dilayani?", answer: "Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  "ac-installation": {
    slug: "ac-installation", icon: Home, audience: "both", kicker: "AC Installation",
    h1: "Instalasi AC di Makassar", heroImage: "https://images.unsplash.com/photo-1762341123870-d706f257a12e?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
    heroImageAlt: "Instalasi unit AC",
    intro: "Instalasi AC untuk rumah maupun komersial, termasuk relokasi unit dan pekerjaan kelistrikan pendukung.",
    seo: { title: "Instalasi AC Makassar | SEJUKARA – CV Angkasa Briliant", description: "Jasa instalasi AC di Makassar untuk rumah dan komersial: pemasangan unit baru, relokasi, dan pekerjaan electrical pendukung. SEJUKARA by CV Angkasa Briliant.", keywords: "instalasi AC Makassar, pasang AC Makassar, relokasi AC Makassar" },
    benefitsTitle: "Instalasi AC yang Rapi & Tepat",
    benefits: ["Untuk hunian dan kebutuhan komersial.", "Termasuk relokasi unit.", "Pekerjaan electrical pendukung.", "Pemasangan sistem sesuai kebutuhan."],
    faqs: [
      { id: "i1", question: "Apakah melayani pasang AC baru?", answer: "Ya, untuk rumah maupun komersial, termasuk relokasi unit." },
      { id: "i2", question: "Bagaimana cara berkonsultasi?", answer: "Hubungi kami via WhatsApp atau isi formulir di halaman ini." },
      { id: "i3", question: "Area mana yang dilayani?", answer: "Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  "maintenance-ac-gedung": {
    slug: "maintenance-ac-gedung",
    icon: Building2,
    audience: "b2b",
    kicker: "Maintenance AC Gedung",
    h1: "Maintenance AC Gedung di Makassar",
    heroImage:
      "https://images.pexels.com/photos/7452378/pexels-photo-7452378.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    heroImageAlt: "Gedung bertingkat modern di Makassar yang memerlukan perawatan AC terpusat",
    intro:
      "Perawatan AC gedung bertingkat, apartemen, dan pusat perbelanjaan secara berkala untuk membantu menjaga kenyamanan penghuni, pengunjung, dan kelancaran operasional properti Anda di Makassar & sekitarnya.",
    seo: {
      title: "Maintenance AC Gedung Makassar | SEJUKARA – CV Angkasa Briliant",
      description:
        "Layanan maintenance AC gedung di Makassar untuk gedung bertingkat, apartemen, dan mall: perawatan berkala, service report, dan kontrak maintenance. SEJUKARA by CV Angkasa Briliant. Konsultasi via WhatsApp.",
      keywords:
        "maintenance AC gedung Makassar, service AC gedung bertingkat Makassar, perawatan AC apartemen Makassar, kontrak maintenance AC gedung, vendor AC gedung Makassar",
    },
    benefitsTitle: "Mengapa Maintenance AC Gedung Penting?",
    benefits: [
      "Menjaga kenyamanan penghuni dan pengunjung di seluruh lantai gedung.",
      "Perawatan terjadwal untuk banyak unit yang lebih terkoordinasi.",
      "Membantu mengurangi risiko gangguan pada area publik dan operasional.",
      "Dokumentasi & service report yang tersusun untuk pengelolaan fasilitas.",
    ],
    faqs: [
      { id: "g1", question: "Apakah melayani maintenance AC untuk gedung bertingkat?", answer: "Ya. Layanan kami mencakup perawatan AC untuk gedung bertingkat, apartemen, dan fasilitas komersial dengan banyak unit." },
      { id: "g2", question: "Apakah bisa menangani banyak unit sekaligus?", answer: "Bisa. Kami menyusun jadwal perawatan berkala yang terkoordinasi untuk kebutuhan gedung dengan banyak unit AC." },
      { id: "g3", question: "Apakah tersedia kontrak maintenance untuk gedung?", answer: "Ya. Tersedia program Maintenance Contract berkala yang disusun setelah survey & assessment gedung." },
      { id: "g4", question: "Area mana yang dilayani?", answer: "Kami fokus melayani kebutuhan AC & HVAC di Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  "maintenance-hvac": {
    slug: "maintenance-hvac",
    icon: Wind,
    audience: "b2b",
    kicker: "Maintenance HVAC",
    h1: "Maintenance HVAC Gedung & Fasilitas di Makassar",
    heroImage:
      "https://images.pexels.com/photos/8065903/pexels-photo-8065903.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    heroImageAlt: "Unit HVAC rooftop pada gedung komersial",
    intro:
      "Program perawatan sistem HVAC untuk gedung dan fasilitas komersial di Makassar — chiller, AHU, ducting, dan distribusi udara — agar performa sistem lebih terjaga dan operasional lebih lancar.",
    seo: {
      title: "Maintenance HVAC Makassar | SEJUKARA – CV Angkasa Briliant",
      description:
        "Layanan maintenance HVAC di Makassar untuk gedung & fasilitas komersial: inspeksi chiller/AHU, ducting, distribusi udara, dan kontrak maintenance berkala. SEJUKARA by CV Angkasa Briliant.",
      keywords:
        "maintenance HVAC Makassar, service HVAC gedung Makassar, perawatan chiller AHU Makassar, maintenance ducting HVAC, kontrak maintenance HVAC Makassar",
    },
    benefitsTitle: "Mengapa Maintenance HVAC Penting?",
    benefits: [
      "Membantu menjaga performa sistem HVAC gedung dan fasilitas komersial.",
      "Perawatan terencana untuk mengurangi risiko gangguan mendadak.",
      "Mencakup inspeksi, troubleshooting, ducting, dan distribusi udara.",
      "Dokumentasi kondisi sistem untuk kebutuhan pengelolaan fasilitas.",
    ],
    faqs: [
      { id: "mh1", question: "Sistem HVAC apa saja yang dilayani?", answer: "Perawatan sistem HVAC untuk gedung dan fasilitas komersial, mencakup inspeksi, troubleshooting, ducting, dan distribusi udara sesuai kebutuhan sistem." },
      { id: "mh2", question: "Apakah tersedia kontrak maintenance HVAC?", answer: "Ya. Tersedia program maintenance berkala untuk fasilitas yang membutuhkan perawatan HVAC rutin." },
      { id: "mh3", question: "Apakah dilakukan survey terlebih dahulu?", answer: "Ya. Survey & assessment dilakukan untuk memeriksa kondisi sistem sebelum menentukan layanan dan penawaran." },
      { id: "mh4", question: "Area mana yang dilayani?", answer: "Makassar dan area layanan yang dapat dijangkau." },
    ],
  },

  "maintenance-contract": {
    slug: "maintenance-contract", icon: CalendarCheck, audience: "b2b", kicker: "Maintenance Contract",
    h1: "Kontrak Maintenance AC & HVAC di Makassar", heroImage: "https://images.pexels.com/photos/32032996/pexels-photo-32032996.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    heroImageAlt: "Kontrak maintenance AC & HVAC",
    intro: "Jangan Tunggu Rusak. Jadwalkan Perawatan. Program kontrak maintenance AC & HVAC berkala untuk perusahaan.",
    seo: { title: "Kontrak Maintenance AC & HVAC Makassar | SEJUKARA – CV Angkasa Briliant", description: "Kontrak maintenance AC & HVAC di Makassar: scheduled inspection, cleaning, preventive maintenance, condition report, dan maintenance history. SEJUKARA by CV Angkasa Briliant.", keywords: "kontrak maintenance AC Makassar, maintenance contract HVAC Makassar, perawatan berkala AC perusahaan" },
    benefitsTitle: "Isi Program Maintenance Contract",
    benefits: ["Scheduled inspection & cleaning.", "Preventive maintenance berkala.", "Condition report & maintenance history.", "Maintenance planning yang terstruktur."],
    faqs: [
      { id: "c1", question: "Apa saja yang termasuk kontrak?", answer: "Inspeksi terjadwal, cleaning, preventive maintenance, condition report, dan riwayat maintenance." },
      { id: "c2", question: "Apakah ada harga tetap?", answer: "Penawaran disusun sesuai kebutuhan setelah survey & assessment." },
      { id: "c3", question: "Area mana yang dilayani?", answer: "Makassar dan area layanan yang dapat dijangkau." },
    ],
  },
};

export default seoPages;
